import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import { Button, Card } from "./ui";

const ICONE = { pagamento: "R$", compromisso: "🗓", prazo: "⚖" };

/**
 * Sino de alertas: pagamentos vencidos/vencendo, compromissos de hoje até
 * +3 dias e prazos processuais próximos. Recarrega a cada 5 minutos — os
 * alertas mudam por passagem de tempo, não por ação do usuário.
 */
const Notificacoes = () => {
    const navigate = useNavigate();
    const [dados, setDados] = useState({ total: 0, criticas: 0, itens: [] });
    const [aberto, setAberto] = useState(false);
    const containerRef = useRef(null);

    const carregar = useCallback(async () => {
        try {
            const { data } = await api.get("/notificacoes");
            setDados(data);
        } catch {
            /* silencioso: alerta é acessório, não pode quebrar a tela */
        }
    }, []);

    useEffect(() => {
        carregar();
        const intervalo = setInterval(carregar, 5 * 60 * 1000);
        return () => clearInterval(intervalo);
    }, [carregar]);

    // Fecha ao clicar fora
    useEffect(() => {
        if (!aberto) return;
        const aoClicar = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) setAberto(false);
        };
        document.addEventListener("mousedown", aoClicar);
        return () => document.removeEventListener("mousedown", aoClicar);
    }, [aberto]);

    const abrirItem = (item) => {
        setAberto(false);
        navigate(item.rota);
    };

    return (
        <div className="sino" ref={containerRef} style={{ position: "relative" }}>
            <Button
                variante="ghost"
                className="btn-icon"
                aria-label={dados.total > 0 ? `${dados.total} alertas` : "Sem alertas"}
                onClick={() => setAberto((v) => !v)}
            >
                <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                </svg>
                {dados.total > 0 && (
                    <span className={`sino-contador ${dados.criticas === 0 ? "aviso" : ""}`}>
                        {dados.total > 9 ? "9+" : dados.total}
                    </span>
                )}
            </Button>

            {aberto && (
                <Card className="painel-notif elev-md">
                    <span className="card-kicker" style={{ padding: "4px 8px" }}>
                        {dados.total > 0 ? `${dados.total} alerta${dados.total > 1 ? "s" : ""}` : "Alertas"}
                    </span>

                    {dados.itens.map((item) => (
                        <button
                            key={`${item.tipo}-${item.id}`}
                            className={`notif-item ${item.severidade}`}
                            onClick={() => abrirItem(item)}
                        >
                            <span aria-hidden="true" style={{ fontSize: 14.5, opacity: 0.8, minWidth: 18 }}>
                                {ICONE[item.tipo]}
                            </span>
                            <span>
                                <span className="notif-titulo">{item.titulo}</span>
                                <br />
                                <span className="notif-detalhe">{item.detalhe}</span>
                            </span>
                        </button>
                    ))}

                    {dados.itens.length === 0 && (
                        <p className="text-muted" style={{ fontSize: 14.5, margin: 0, padding: "8px" }}>
                            Nenhum prazo, compromisso ou pagamento nos próximos dias.
                        </p>
                    )}
                </Card>
            )}
        </div>
    );
};

export default Notificacoes;
